import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEvent } from "@/context/EventContext";
import { Printer, ArrowLeft, Heart } from "lucide-react";

const PLUS = { none: "", plus_1: "+1", plus_2: "+2", plus_3: "+3", family: "& Family", family_friends: "& Family & Friends" };
const STATUS = { attending: "Attending", declined: "Declined", pending: "Pending" };

export default function PrintGuests() {
  const navigate = useNavigate();
  const { eapi, event, eventId } = useEvent();
  const [guests, setGuests] = useState([]);
  const title = event?.title || "Guest List";

  useEffect(() => { eapi.get("/guests").then(({ data }) => setGuests(data)).catch(() => {}); }, [eapi]);

  const plusText = (g) => {
    const names = (g.plus_ones || []).filter(Boolean);
    const base = PLUS[g.plus_one_option] || "";
    if (names.length) return base ? `${base} (${names.join(", ")})` : names.join(", ");
    return base;
  };
  const attending = guests.filter((g) => g.rsvp_status === "attending").length;

  return (
    <div style={{ background: "#fff" }} className="min-h-screen text-stone-800">
      <div className="print:hidden sticky top-0 bg-white border-b border-[#E8E6E1] px-6 py-3 flex items-center justify-between">
        <button onClick={() => navigate(`/e/${eventId}/guests`)} data-testid="print-guests-back-btn" className="flex items-center gap-2 text-sm text-stone-500 hover:text-stone-800"><ArrowLeft size={16} /> Back to guests</button>
        <button onClick={() => window.print()} data-testid="do-print-guests-btn" className="flex items-center gap-2 rounded-full bg-[#2C2A28] text-white px-5 py-2 text-sm hover:bg-[#8C9A86] transition-colors"><Printer size={15} /> Print</button>
      </div>
      <div className="max-w-5xl mx-auto px-8 py-10" data-testid="print-guests-page">
        <div className="text-center mb-8">
          <Heart size={20} className="mx-auto text-[#8C9A86] mb-2" fill="#8C9A86" />
          <h1 className="font-serif text-4xl tracking-tight">{title}</h1>
          <p className="text-sm text-stone-400 mt-1">Guest list &middot; {guests.length} guests &middot; {attending} attending</p>
        </div>
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="border-b-2 border-stone-300 text-left">
              <th className="py-2 pr-3">Name</th>
              <th className="py-2 pr-3">RSVP</th>
              <th className="py-2 pr-3">Meal</th>
              <th className="py-2 pr-3">Dietary</th>
              <th className="py-2 pr-3">Plus-ones</th>
              <th className="py-2 pr-3">Song</th>
              <th className="py-2 pr-3">Accessibility</th>
            </tr>
          </thead>
          <tbody>
            {guests.map((g) => (
              <tr key={g.id} data-testid={`print-guest-row-${g.id}`} className="border-b border-stone-200 break-inside-avoid align-top">
                <td className={`py-2 pr-3 font-medium ${g.linked_to ? "pl-6 text-stone-600" : ""}`}>{g.first_name} {g.last_name}{g.is_plus_one ? <span className="text-[#9c7d3f]"> &middot; +1</span> : g.linked_to ? <span className="text-stone-400"> &middot; linked</span> : ""}</td>
                <td className="py-2 pr-3">{STATUS[g.rsvp_status] || "Pending"}</td>
                <td className="py-2 pr-3">{g.meal_choice || "—"}</td>
                <td className="py-2 pr-3">{g.dietary || "—"}</td>
                <td className="py-2 pr-3">{plusText(g) || "—"}</td>
                <td className="py-2 pr-3">{g.song_request || "—"}</td>
                <td className="py-2 pr-3">{g.accessibility || "—"}</td>
              </tr>
            ))}
            {guests.length === 0 && <tr><td colSpan={7} className="py-8 text-center text-stone-400">No guests yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
